import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_READYFORFINAL_START,
} from '../../actions/types'

import {
  updateReadyForFinalSuccess,
  updateReadyForFinalFailure,
} from '../../actions'

import {
  getLoanApplicationId,
} from '../../reducers'

import {
  gotoLoanApplicationUser
} from '../../requesters/loanApplicationUser'

function* readyForFinal(action) {
  const loanApplicationId = yield select(getLoanApplicationId);
  const { response, error } = yield call(gotoLoanApplicationUser, loanApplicationId, 'confirm_approval')

  if (response) {
    yield put(updateReadyForFinalSuccess(response))
  } else {
    yield put(updateReadyForFinalFailure(error.response.data.errors))
  }
}

export function* watchReadyForFinal() {
  yield takeLatest(UPDATE_READYFORFINAL_START, readyForFinal);
}
